let lenisInstance = null;
export const setLenis = (l) => { lenisInstance = l; };
export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: 0, duration: 1.8 });
  else el.scrollIntoView({ behavior: 'smooth' });
}
